import { useTheme } from '@mui/material/styles';
import TwoDTable, { Columns } from '../molecules/TwoDTable';
import { DashboardMissionData, KPIType } from '@bloomays-lib/types.shared';
import { buildMonthYearInterval } from '@bloomays-lib/utils.shared';
import { formatMissionPlanning } from '../../helpers/missionPlanning';
import { useTranslation } from 'react-i18next';

export type ColorPalette = {
  M: string;
  D: string;
  NS: string;
  F: string;
  EB: string;
  BE: string;
  BR: string;
  white: string;
  red: string;
  green: string;
};

export type MissionPlanningProps = {
  rawData: DashboardMissionData;
  isLoading?: boolean;
  startDate: Date;
  openMissionsPopin: (kpi: KPIType, month: string, missionIds: string[], estimatedMissionIds: string[]) => void;
};

const MissionPlanning = ({ rawData, isLoading, startDate = new Date(), openMissionsPopin }: MissionPlanningProps) => {
  const { t } = useTranslation(['random', 'KPI']);
  const theme = useTheme();

  const columns: Columns[] = [{ columnName: 'KPI', title: t('KPI', { ns: 'random' }) }];
  const interval = buildMonthYearInterval(startDate, {
    fullYear: true,
  });
  interval.forEach((column) => {
    columns.push({ columnName: column, title: column });
  });
  columns.push({
    columnName: 'average',
    title: t('average', { ns: 'random' }),
  });

  const colorPalette: ColorPalette = {
    M: theme.palette.blue[100],
    D: theme.palette.blue[80],
    NS: theme.palette.blue[60],
    F: theme.palette.other.yellowStar,
    EB: theme.palette.other.yellowMedium,
    BE: theme.palette.other.yellow,
    BR: theme.palette.purple[60],
    white: theme.palette.neutral.white,
    green: '#08a81c',
    red: theme.palette.red[80],
  };

  const rows = formatMissionPlanning(rawData, colorPalette, openMissionsPopin);

  return <TwoDTable columns={columns} isLoading={isLoading} rows={rows} />;
};

export default MissionPlanning;
export { MissionPlanning };
